import { render, staticRenderFns } from "./Include.vue?vue&type=template&id=51810840"
import script from "./Include.vue?vue&type=script&lang=js"
export * from "./Include.vue?vue&type=script&lang=js"
import style0 from "./Include.vue?vue&type=style&index=0&id=51810840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports